// Challenge rooms — the client half.
//
// A room is a short code. Everyone who opens it plays the same matchups, and
// the table of results lives on the server, so it is still there after a
// refresh, a closed tab, or a week away. The only thing kept on the device is
// which name this person plays under, so we can show them their own row.

const NAME_KEY = 'challengeName';
const TOKEN_KEY = 'challengeToken';

// This device's claim on its own row. Two friends can both be called Fahad;
// only one of them is the Fahad who owns that line in this room.
export const deviceToken = () => {
  try {
    let t = localStorage.getItem(TOKEN_KEY);
    if (!t) {
      t = (crypto.randomUUID && crypto.randomUUID())
        || `t-${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(TOKEN_KEY, t);
    }
    return t;
  } catch (e) {
    return '';   // private mode: the row simply stays unclaimed
  }
};

export const getSavedName = () => {
  try { return localStorage.getItem(NAME_KEY) || ''; } catch (e) { return ''; }
};

export const saveName = (name) => {
  try { localStorage.setItem(NAME_KEY, name); } catch (e) { /* private mode */ }
};

export async function createChallenge({ game, seed, rounds, name }) {
  const res = await fetch('/api/challenge', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ action: 'create', game, seed, rounds, name }),
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.error || 'Could not make the challenge');
  return data.code;
}

export async function loadChallenge(code) {
  const res = await fetch(`/api/challenge?code=${encodeURIComponent(code)}`);
  if (!res.ok) return null;
  const data = await res.json();
  return data.success ? data : null;
}

export async function submitChallengeScore({ code, name, score, time, answers, final, status }) {
  const res = await fetch('/api/challenge', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      action: 'submit', code, name, score, time, answers, final, status, token: deviceToken(),
    }),
  });
  const data = await res.json();
  if (!data.success) {
    const err = new Error(data.error || 'Could not save your score');
    err.taken = !!data.taken;
    throw err;
  }
  return data;
}
